import { jsx as t } from "react/jsx-runtime";
function e(o) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "20",
      height: "14",
      viewBox: "0 0 20 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "rgb(var(--text-secondary))",
      ...o,
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M19 5H1M19 13H1M19 1H1M19 9H1",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
export {
  e as default
};
